<div class="mx-4 mt-4 mb-4 equipments-container">
        <div class="page-header" id="tour-eq-header">
            <div class="flex justify-content-between align-items-center mb-3">
                <div class="flex align-items-center gap-3">
                    <h2 class="m-0 text-900 font-bold">Gestión de Equipos</h2>
                    <p-button icon="pi pi-question-circle" label="Ayuda" (onClick)="openGuide()" severity="info" [text]="true" id="tour-eq-help"></p-button>
                </div>
                <p-button label="Nuevo Equipo" icon="pi pi-plus" [rounded]="true" (onClick)="openNew()"></p-button>
            </div>
            <div class="subtitle-container mb-4">
                <p class="page-subtitle m-0 text-500">Administre el catálogo de equipos del laboratorio, controle sus
                    estados y realice el seguimiento de mantenimientos y calibraciones.</p>
            </div>
        </div>

        <!-- Stats Cards -->
        <div class="grid mb-4" *ngIf="stats()" id="tour-eq-stats">
            <div class="col-12 md:col-6 lg:col-3">
                <div
                    class="surface-card shadow-2 p-3 border-round border-left-3 border-blue-500 h-full flex justify-content-between align-items-center">
                    <div>
                        <span class="block text-500 font-medium mb-2 text-sm">Total Equipos</span>
                        <div class="text-900 font-bold text-xl">{{ stats().totalEquipments }}</div>
                    </div>
                    <div class="flex align-items-center justify-content-center bg-blue-100 border-round flex-shrink-0"
                        style="width:2.5rem;height:2.5rem">
                        <i class="pi pi-desktop text-blue-500 text-xl" style="line-height: 0"></i>
                    </div>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <div
                    class="surface-card shadow-2 p-3 border-round border-left-3 border-green-500 h-full flex justify-content-between align-items-center">
                    <div>
                        <span class="block text-500 font-medium mb-2 text-sm">Operativos</span>
                        <div class="text-900 font-bold text-xl">{{ stats().operational }}</div>
                    </div>
                    <div class="flex align-items-center justify-content-center bg-green-100 border-round flex-shrink-0"
                        style="width:2.5rem;height:2.5rem">
                        <i class="pi pi-check-circle text-green-500 text-xl" style="line-height: 0"></i>
                    </div>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <div
                    class="surface-card shadow-2 p-3 border-round border-left-3 border-orange-500 h-full flex justify-content-between align-items-center">
                    <div>
                        <span class="block text-500 font-medium mb-2 text-sm">Próximos Vencimientos</span>
                        <div class="text-900 font-bold text-xl">{{ stats().nextEvents }}</div>
                    </div>
                    <div class="flex align-items-center justify-content-center bg-orange-100 border-round flex-shrink-0"
                        style="width:2.5rem;height:2.5rem">
                        <i class="pi pi-calendar text-orange-500 text-xl" style="line-height: 0"></i>
                    </div>
                </div>
            </div>
            <div class="col-12 md:col-6 lg:col-3">
                <div
                    class="surface-card shadow-2 p-3 border-round border-left-3 border-red-500 h-full flex justify-content-between align-items-center">
                    <div>
                        <span class="block text-500 font-medium mb-2 text-sm">Fuera de Servicio</span>
                        <div class="text-900 font-bold text-xl">{{ stats().outOfService }}</div>
                    </div>
                    <div class="flex align-items-center justify-content-center bg-red-100 border-round flex-shrink-0"
                        style="width:2.5rem;height:2.5rem">
                        <i class="pi pi-exclamation-triangle text-red-500 text-xl" style="line-height: 0"></i>
                    </div>
                </div>
            </div>
        </div>

        <!-- Table Section -->
        <div class="surface-card shadow-2 border-round p-4 mt-4" id="tour-eq-table">
            <table-dynamic [config]="tableConfig()" [actionButtons]="tableActions()" (onNew)="openNew()"
                (onEdit)="openEdit($event)" (onDelete)="confirmDelete($event)" (onLazyLoad)="loadData($event)" (onDblClick)="onRowDblClick($event)"
                (onCustomAction)="handleCustomAction($event)">
            </table-dynamic>
        </div>
</div>


<!-- Equipment Form Modal -->
<app-equipment-form
    [visible]="showForm()"
    [item]="equipmentFormValue()"
    [loading]="loading()"
    (visibleChange)="showForm.set($event)"
    (onSave)="saveEquipment($event)">
</app-equipment-form>

